import { forwardRef, type InputHTMLAttributes } from 'react'
import { cn } from '../lib/cn'

export type CheckboxProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, ...props }, ref) => (
    <input
      ref={ref}
      type="checkbox"
      className={cn(
        'h-4 w-4 rounded border-border-default text-brand-primary focus:ring-2 focus:ring-brand-primary focus:ring-offset-1',
        className,
      )}
      {...props}
    />
  ),
)
Checkbox.displayName = 'Checkbox'
